export default __webpack_public_path__ + "components/smartbar/static/smartbanner-icon-3b40983c2d1bd705a08855f1655e6af4.png";